export const decodeSideBarMenuModel = (sideBarMenuModel) => {
    return {
        packageReportSocialCount: sideBarMenuModel.package_report_social_count
    };
};
